var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebFooterLiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0396 36.6004H17.9604C8.05715 36.6004 0 28.5409 0 18.6348V18.5555C0 8.64936 8.05715 0.589844 17.9604 0.589844H18.0396C27.9429 0.589844 36 8.64936 36 18.5555V18.6348C36 28.5409 27.9429 36.6004 18.0396 36.6004ZM17.9604 1.80876C8.72858 1.80876 1.21856 9.32099 1.21856 18.5555V18.6348C1.21856 27.8693 8.72858 35.3815 17.9604 35.3815H18.0396C27.2714 35.3815 34.7814 27.8693 34.7814 18.6348V18.5555C34.7814 9.32099 27.2714 1.80876 18.0396 1.80876H17.9604Z",
    fill: "#059669"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90088 12.7635C8.4427 12.3381 8.21484 11.8115 8.21484 11.185C8.21484 10.5584 8.44392 10.0087 8.90088 9.58207C9.35906 9.15667 9.94885 8.94336 10.6715 8.94336C11.3941 8.94336 11.9607 9.15667 12.4177 9.58207C12.8758 10.0075 13.1037 10.5426 13.1037 11.185C13.1037 11.8273 12.8746 12.3381 12.4177 12.7635C11.9595 13.1889 11.3782 13.4022 10.6715 13.4022C9.96469 13.4022 9.35906 13.1889 8.90088 12.7635ZM12.7186 15.2037V28.2462H8.59868V15.2037H12.7186Z",
    fill: "#059669"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4316 16.492C27.3296 17.4671 27.7781 18.8055 27.7781 20.5096V28.0157H23.8653V21.0386C23.8653 20.1792 23.6423 19.5113 23.1975 19.0359C22.7527 18.5605 22.1532 18.3216 21.4026 18.3216C20.6519 18.3216 20.0524 18.5593 19.6076 19.0359C19.1628 19.5113 18.9398 20.1792 18.9398 21.0386V28.0157H15.0039V15.1671H18.9398V16.8711C19.3383 16.3031 19.8757 15.8545 20.5508 15.5242C21.2259 15.1939 21.985 15.0293 22.8295 15.0293C24.3332 15.0293 25.5347 15.5169 26.4316 16.492Z",
    fill: "#059669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebFooterLiIcon);
export default __webpack_public_path__ + "static/media/web_footer_LI_icon.4ade2ac7d65bdd0695efc080d7044432.svg";
export { ForwardRef as ReactComponent };